// extracted by mini-css-extract-plugin
export default {"control":"control_control__xFUak","addIcon":"control_addIcon__GeyVO"};